import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';
import DocRowContainer from '../../cmn/DocRowContainer'
import { UiBox, UiCol } from "../../../library/layout/Index";

const ProfileMemRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <UiCol>
            <DocRowContainer formObject={formObject} rowKey={rowKey} >
                <UiBox>
                    <div className="uiSpacer5">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "club" }}
                            className="uiHeaderElement"
                        />
                    </div>
                    <div>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "memName" }}
                            className="uiInline"
                        />
                    </div>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "memType" }}
                        className="uiHeaderElement"
                    />
                    :
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "memNumber" }}
                        className="uiInline"
                    />
                    <div className="uiSpacer5">
                        <div className="uiRowHeight1">
                            <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "remarks" }}
                                className="uiInline"
                            />
                        </div>
                    </div>
                </UiBox>
            </DocRowContainer>
        </UiCol>
    )
}

export default ProfileMemRow